// extracted by mini-css-extract-plugin
module.exports = {"roundButton":"RoundButton-module__roundButton___2ejmb","arrowButton":"RoundButton-module__arrowButton___2tEf5","disabled":"RoundButton-module__disabled___1EO2W"};